import { EdgeInsets } from './SafeArea.types';

const initialWindowSafeAreaInsets: EdgeInsets | null = null;
export default initialWindowSafeAreaInsets;
